import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Decoders } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/monitors/decoders`,
    response: [] as Decoders.Get.Status[],
    query: {} as { after: string; sorted?: boolean },
    method: HTTP_METHODS.GET,
  },
};
